"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masterEditionAddress = exports.metadataAddress = exports.tokenAccountMint = void 0;
const utf8_1 = require("@project-serum/anchor/dist/cjs/utils/bytes/utf8");
const web3_js_1 = require("@solana/web3.js");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
async function tokenAccountMint(connection, tokenAccount) {
    const account = (await connection.getParsedAccountInfo(tokenAccount)).value
        .data;
    return new web3_js_1.PublicKey(account.parsed.info.mint);
}
exports.tokenAccountMint = tokenAccountMint;
async function metadataAddress(mint) {
    const [metadataAddress] = await web3_js_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('metadata'), mpl_token_metadata_1.PROGRAM_ID.toBytes(), mint.toBytes()], mpl_token_metadata_1.PROGRAM_ID);
    return metadataAddress;
}
exports.metadataAddress = metadataAddress;
async function masterEditionAddress(mint) {
    const [masterEditionAddress] = await web3_js_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('metadata'), mpl_token_metadata_1.PROGRAM_ID.toBytes(), mint.toBytes(), (0, utf8_1.encode)('edition')], mpl_token_metadata_1.PROGRAM_ID);
    return masterEditionAddress;
}
exports.masterEditionAddress = masterEditionAddress;
//# sourceMappingURL=utils.js.map